// extracted by mini-css-extract-plugin
module.exports = {"menuItemWrapper":"MenuItem_menuItemWrapper__9IxE0","menuLabel":"MenuItem_menuLabel__icXhD"};